export interface SubscriptionCheckout {
    subscriptionId: string;
    status: string;
    paymentIntentStatus: string | null;
    clientSecret: string;
    amount: number | null;
    currency: string | null;
    alreadyExists?: boolean;
}

export type CheckoutState = 'ready' | 'existing' | 'paid' | 'pending' | 'unavailable';

/** A saved card is never the thing confirmed here: the secret must describe a payable invoice. */
export function checkoutState(checkout: SubscriptionCheckout): CheckoutState {
    if (checkout.status === 'active' || checkout.status === 'trialing') return 'existing';
    if (checkout.paymentIntentStatus === 'succeeded') return 'paid';
    if (checkout.paymentIntentStatus === 'processing' || checkout.paymentIntentStatus === 'requires_capture') return 'pending';
    if (checkout.status === 'incomplete'
        && ['requires_payment_method', 'requires_action', 'requires_confirmation'].includes(checkout.paymentIntentStatus || '')
        && checkout.clientSecret.startsWith('pi_')
        && Number.isSafeInteger(checkout.amount) && (checkout.amount || 0) > 0
        && checkout.currency === 'eur') return 'ready';
    return 'unavailable';
}

export function paymentAmount(amount: number, currency: string): string {
    return new Intl.NumberFormat('sk-SK', { style: 'currency', currency }).format(amount / 100);
}

/** Keep retries on the same Stripe request, including browsers without crypto.randomUUID. */
export function newCheckoutAttemptId(): string {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
